//import { useRouter } from "next/router";
import { useMediaQuery } from '@mantine/hooks';
import newlogo from  '../assets/images/jb-dashbaord-logo.svg'
import { useLocation } from 'react-router-dom';
import {BASEURL} from '../helpers/url_helper';
export default function isValidPassword(password) {
  // Regular expressions to check for each requirement
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const numberRegex = /[0-9]/;
  const specialCharRegex = /[^A-Za-z0-9]/; // Matches any character that is not alphanumeric

  // Check if all conditions are met
  const hasUppercase = uppercaseRegex.test(password);
  const hasLowercase = lowercaseRegex.test(password);
  const hasNumber = numberRegex.test(password);
  const hasSpecialChar = specialCharRegex.test(password);

  // Return true if all conditions are met, otherwise false
  return hasUppercase && hasLowercase && hasNumber && hasSpecialChar;
}

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export const useCurrentUrl = () => {
  const location = useLocation();
  return location.pathname; 
};

export function isPassword(val) {
  return !val ? "Password is Required" : null;
}
export function isUserName(val) {
  return !val ? "Customer ID is Required" : null;
}
export function hasMinimumLength(val) {
  return val?.length > 7 ? "Minimum 8 characters" : null;
}

export function hasNoStartingNumber(val) {
  if (isNaN(val.charAt(0))) {
    return "Should not start with a number";
  }
  return null;
}

export function hasNumber(val) {
  return /\d/.test(val) ? "Minimum One number" : null;
}

export function hasSpecialCharacter(val) {
  return /[!@#$%^&*()\-_=+{};:,<.>]/.test(val)
    ? "Include a special character"
    : null;
}

export function hasCapitalLetter(val) {
  return /[A-Z]/.test(val) ? "Minimum One CAPITAL letter" : null;
}

export function validateUserName(val) {
  if (!val) {
    return "Customer ID  is required";
  }
  return val.length < 2 ? "Customer ID must have at least 2 letters" : null;
}

export function validateFirstName(val) {
  if (!val) {
    return "FirstName  is required";
  }
  return val.length < 2 ? "FirstName must have at least 2 letters" : null;
}
export function validateClientName(val) {
  if (!val) {
    return "Client Name is required";
  }
  return val.length < 2 ? "Client Name must have at least 2 letters" : null;
}
export function validateuploadlogo(file) {
  if (!file) {
    return "Logo is required";
  }
  if (typeof file === 'string') {
    const validExtensions = ['.png', '.jpg', '.jpeg'];
    const isValidUrl = validExtensions.some(ext => file.endsWith(ext));
    if (!isValidUrl) {
      return "Invalid file type. Only Images are allowed.";
    }
  } else if (file instanceof File) {
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      return "Invalid file type. Only Images are allowed.";
    }
  }
}

export function validateLastName(val) {
  if (!val) {
    return "Last Name is required";
  }
  return val.length < 2 ? "Last Name must have at least 2 letters" : null;
}

export function validateAddress(val) {
  if (!val) {
    return "Address is required";
  }
  return val.length < 2 ? "Address must have at least 2 letters" : null;
}
export function validateLatitude(val) {
  const lat = parseFloat(val);
  if (isNaN(lat)) {
      return 'Latitude must be number';
  }
  return null; 
};

export function validateLongitude (val) {
  const lat = parseFloat(val);
  if (isNaN(lat)) {
      return 'Longitude must be number';
  }
  return null;
};

export function validateEmail(val) {
  if (!val) {
    return "Email is required";
  }
  return /^\S+@\S+\.\S+$/.test(val)
    ? null
    : "Please enter a valid email address";
}
export function validateName(val) {
  if (!val) {
    return 'Applicant Name is required';
  } else if (/\d/.test(val)) {
    return 'Applicant Name cannot contain numbers';
  }
  return null;
};
export function validateSiteName(val) {
  if (!val) {
    return 'Site Name is required';
  }
  return null;
};

export function validatePhoneNumber(val) {
  if (!val) {
    return "Phone number is required";
  }
  // Assuming the phone number string should include a country code and can be quite long
  const cleaned = val.replace(/\D/g, ""); // Remove non-numeric characters
  if (cleaned.length < 12 || cleaned.length > 12) {
    return "Invalid phone number";
  }
  return null;
}

export function validateoldpasswordsimple(val, passwordVal) {
  if (!val) {
    return "Password is required";
  }
  return passwordVal ? null : "Invalid Password";
}

export function validateNewPassword(val, passwordVal) {
  if (!val) {
    return "New Password is required";
  }
  return passwordVal ? null : "Invalid Password";
}
export function validateConfirmPassword(value, password) {
  if (!value) {
    return "Confirm Password is required";
  }
  if (value !== password) {
    return "Passwords did not match";
  }
  return null;
}
 export function validatePassword(val,fieldName = "Password") {
  if (!val) {
    return `${fieldName} is required`;
  }
  if (!isNaN(val.charAt(0))) {
    return "Should not start with number";
  }
  if (val?.length < 7) {
    return "Password should have at least 8 characters";
  }
  // Regular expression to check for at least one uppercase letter, one lowercase letter,
  // one number, and one special character
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>])(?=.*[^\s]).{8,}$/;

  return passwordRegex.test(val)
    ? null
    : "Please enter valid password";
}
export function validateimageUrlFields(value, values) {
   if (!value && !values.uploadFile) {
    return 'Either a URL or a file upload is required.';
  }
  if (value && values.uploadFile) {
    return 'You can either provide a URL or upload a file, not both.';
  }

  if (value) {
    const regex = new RegExp(
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/
    );
    return regex.test(value) ? null : "Please enter a valid URL.";
  }

  return null;
}
export function validateuploadFileFields(value, values) {
  if (!value && !values.imageUrl) {
    return 'Either an URL or a file upload is required.';
  }
  if (value && values.imageUrl) {
    return 'You can either provide an URL or upload a file, not both.';
  }
  // if (value && !values.imageUrl) {
  //   const allowedFileTypes = ['application/pdf','text/plain','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document' ];
  //   if (value.type && !allowedFileTypes.includes(value.type)) {
  //     return 'Please upload only file ';
  //   }
  // }
  return null;
}

export function validateOldPassword(val) {
  if (!val) {
    return "Password is required";
  }
  if (val.length < 8) {
    return "Password should have at least 8 characters";
  }
}

// useCustomMediaQuery.ts
export function useCustomMediaQuery() {
  const isSmallScreen = useMediaQuery('(max-width: 640px)');
  const isSmallScreenTab = useMediaQuery('(max-width: 800px)');
  const isSmallScreenTablet = useMediaQuery('(max-width: 901px)');
  const isMediumScreen = useMediaQuery('(min-width: 641px) and (max-width: 1024px)');
  const isLargeScreen = useMediaQuery('(min-width: 1025px)');
  const isLargeScreenmin = useMediaQuery('(min-width: 902px)');

  return {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isSmallScreenTab,
    isSmallScreenTablet,
    isLargeScreenmin
  };
}
export const Logo = newlogo;

// placeholder color design ui
export const PlaceholderUi = "border-current-secondary-color placeholder-input_placeholder"

export const changeImageUrl = (url) => {
  return url?.replace(BASEURL, '');
}
// export const changeImageUrl = (url) => {
//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8081';
//   const updatedUrl = url?.replace('http://192.168.0.26:8027', baseUrl); 
//   return updatedUrl;
// };
